import React from 'react';
import { DOWNLOAD_LINKS } from '../../config/downloadLinks';
import './DesktopDownloadButtons.css';

const DesktopDownloadButtons = ({ platform }) => {
  const renderWindowsButton = () => (
    <a href={DOWNLOAD_LINKS.WINDOWS} className="desktop-download-button windows">
      <svg className="download-icon" viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
      <span>Download for<br/>Windows</span>
    </a>
  );

  const renderMacOSButton = () => (
    <a href={DOWNLOAD_LINKS.MACOS} className="desktop-download-button mac">
      <svg className="download-icon" viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
      <span>Download for<br/>MacOS</span>
    </a>
  );

  // If platform is specified, render only that button
  if (platform === 'windows') {
    return <div className="desktop-download-buttons">{renderWindowsButton()}</div>;
  }
  
  if (platform === 'macos') {
    return <div className="desktop-download-buttons">{renderMacOSButton()}</div>;
  }

  // Default behavior: render both buttons
  return (
    <div className="desktop-download-buttons">
      {renderWindowsButton()}
      {renderMacOSButton()}
    </div>
  );
};

export default DesktopDownloadButtons; 